// extracted by mini-css-extract-plugin
export default {"root":"RGvmxdqqtaa94CkC_6kN","text-label":"qMqmnlKahhZO65LqigZR"};